import React from "react"
import { Button, HStack, Text } from "@chakra-ui/react"
import { PlusIcon, CheckIcon } from "@heroicons/react/24/outline"
import { c } from "../classroomColors"

export function TopicPill({ label, isSelected, onClick }) {
  return (
    <Button
      variant="unstyled"
      onClick={onClick}
      display="inline-flex"
      padding="8px 14px"
      height="auto"
      justifyContent="center"
      alignItems="center"
      borderRadius="24px"
      fontSize="12px"
      fontWeight={500}
      lineHeight="normal"
      border="1px solid"
      borderColor={isSelected ? c.solidBg : c.border}
      background={isSelected ? c.solidBg : c.surfaceSubtle}
      color={isSelected ? c.solidText : c.text}
      _hover={{
        background: isSelected ? c.solidBg : c.hover,
        borderColor: isSelected ? c.solidBg : c.textMuted,
      }}
    >
      <HStack spacing="8px">
        <Text>{label}</Text>
        {isSelected ? (
          <CheckIcon width={13} height={13} />
        ) : (
          <PlusIcon width={13} height={13} style={{ opacity: 0.55 }} />
        )}
      </HStack>
    </Button>
  )
}
